import React from "react";
import { useDisplayDividend } from "../../../data/reports/dividends/hooks/useDisplayDividends";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { DividendData, DividendList,} from "../../../data/reports/dividends/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { DisplayDividendsMainAttributes } from "./DisplayDividendsMainAttributes";
import { ExpansionPanel, ExpansionPanelSummary, Typography, Grid, IconButton,} from "@material-ui/core";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import PrintIcon from "@material-ui/icons/PrintOutlined";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import { useDividendsPrinter } from "../../../data/reports/dividends/hooks/useDividendsPrinter";

export interface DisplayDividendsProps {
  id?: string;
  enablePrint?: boolean;
}

export const DisplayDividends: React.FunctionComponent<DisplayDividendsProps> = ({
  id,
  enablePrint,
}) => {
  const dividends = useDisplayDividend(id);
  const { getString } = React.useContext(LocalizationContext);
	const [download, fetchState] = useDividendsPrinter(dividends);

  return !dividends ? (
    <>{"loading placeholder"}</>
  ) : (
    <Grid container justify="center" direction="column">
      <ExpansionPanel expanded>
        <ExpansionPanelSummary>
          <Grid container justify="space-between">
            <Grid item>
              <Typography>{getString("tableBasciInfo")}</Typography>
            </Grid>
            <Grid item>
            <CustomTooltip titleKeyword="exportPDFTooltip">
									<IconButton
										color="secondary"
										component="span"
										onClick={download}
										disabled={fetchState.type !== "not-started"}
									>
										<DownloadIcon />
									</IconButton>
								</CustomTooltip>
                { fetchState.type !== "not-started"  ? getString("pleaseWait") : null }
							</Grid>
            </Grid>
        </ExpansionPanelSummary>
        <DisplayDividendsMainAttributes dividends={dividends} />
      </ExpansionPanel>
    </Grid>
  );
};

export const useViewDividends = (enablePrint?: boolean) => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  return React.useCallback(
    (dividends: DividendList) =>
      showWithDrawer(
        <DisplayDividends id={dividends.tranId} enablePrint={enablePrint} />
      ),
    [showWithDrawer]
  );
};
